import { css } from '@emotion/react';

const fontsStyle = css`
  @font-face {
    font-family: 'Pretendard';
    font-display: swap;
    src: url('./assets/fonts/inter/Pretendard-Regular.otf') format('otf');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 900;
    font-display: swap;
    src: local('Inter Black'), url('./assets/fonts/inter/Inter-Black.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Black.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Black.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 800;
    font-display: swap;
    src: local('Inter ExtraBold'), url('./assets/fonts/inter/Inter-ExtraBold.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Black.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Black.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 700;
    font-display: swap;
    src: local('Inter Bold'), url('./assets/fonts/inter/Inter-Bold.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Bold.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Bold.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 600;
    font-display: swap;
    src: local('Inter SemiBold'), url('./assets/fonts/inter/Inter-SemiBold.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Bold.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Bold.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 500;
    font-display: swap;
    src: local('Inter Medium'), url('./assets/fonts/inter/Inter-Medium.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Medium.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Medium.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 400;
    font-display: swap;
    src: local('Inter Regular'), url('./assets/fonts/inter/Inter-Regular.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Regular.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Regular.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 300;
    font-display: swap;
    src: local('Inter Light'), url('./assets/fonts/inter/Inter-Light.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Light.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Light.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 200;
    font-display: swap;
    src: local('Inter ExtraLight'), url('./assets/fonts/inter/Inter-ExtraLight.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-ExtraLight.woff') format('woff'),
      url('./assets/fonts/inter/Inter-ExtraLight.woff2') format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-weight: 100;
    font-display: swap;
    src: local('Inter Thin'), url('./assets/fonts/inter/Inter-Thin.ttf') format('ttf'),
      url('./assets/fonts/inter/Inter-Thin.woff') format('woff'),
      url('./assets/fonts/inter/Inter-Thin.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 900;
    font-display: swap;
    src: local('NotoSansKR Black'), url('./assets/fonts/noto-sans-kr/NotoSansKR-Black.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Black.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Black.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 800;
    font-display: swap;
    src: local('NotoSansKR ExtraBold'), url('./assets/fonts/noto-sans-kr/NotoSansKR-ExtraBold.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-ExtraBold.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-ExtraBold.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 700;
    font-display: swap;
    src: local('NotoSansKR Bold'), url('./assets/fonts/noto-sans-kr/NotoSansKR-Bold.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Bold.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Bold.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 600;
    font-display: swap;
    src: local('NotoSansKR SemiBold'), url('./assets/fonts/noto-sans-kr/NotoSansKR-SemiBold.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-SemiBold.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-SemiBold.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 500;
    font-display: swap;
    src: local('NotoSansKR Medium'), url('./assets/fonts/noto-sans-kr/NotoSansKR-Medium.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Medium.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Medium.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 400;
    font-display: swap;
    src: local('NotoSansKR Regular'), url('./assets/fonts/noto-sans-kr/NotoSansKR-Regular.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Regular.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Regular.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 300;
    font-display: swap;
    src: local('NotoSansKR Light'), url('./assets/fonts/noto-sans-kr/NotoSansKR-Light.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Light.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Light.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 200;
    font-display: swap;
    src: local('NotoSansKR ExtraLight'), url('./assets/fonts/noto-sans-kr/NotoSansKR-ExtraLight.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-ExtraLight.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-ExtraLight.woff2') format('woff2');
  }

  @font-face {
    font-family: 'NotoSansKR';
    font-weight: 100;
    font-display: swap;
    src: local('NotoSansKR Thin'), url('./assets/fonts/noto-sans-kr/NotoSansKR-Thin.otf') format('otf'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Thin.woff') format('woff'),
      url('./assets/fonts/noto-sans-kr/NotoSansKR-Thin.woff2') format('woff2');
  }
`;

export default fontsStyle;
